import type { RouteRecordRaw } from "vue-router"

export const FlexShopperApplyRoutes: RouteRecordRaw[] = [
  {
    name: "flexshopper-apply-routes",
    path: "flexshopper_standard",
    children: [
      {
        name: "flexshopper-apply-start",
        path: "start",
        component: () => import("./pages/FlexShopperIntroView.vue"),
        meta: {
          next: "verification",
        },
      },
      {
        name: "flexshopper-apply-verification",
        path: "verification",
        redirect(to) {
          return {
            path: `${to.path}/start`,
          }
        },
        children: [
          {
            name: "flexshopper-apply-verification-start",
            path: "start",
            component: () => import("./pages/FlexShopperVerifyStartView.vue"),
            meta: {
              next: "sent",
            },
          },
          {
            name: "flexshopper-apply-verification-sent",
            path: "sent",
            component: () => import("./pages/FlexShopperVerifySentView.vue"),
            meta: {
              next: "application",
            },
          },
        ],
      },
      {
        name: "flexshopper-apply-decisions",
        path: "decision",
        meta: {
          step: "decision",
        },
        children: [
          {
            name: "flexshopper-apply-approved",
            path: "approved",
            component: () => import("./pages/FlexShopperApprovedView.vue"),
          },
          {
            name: "flexshopper-apply-declined",
            path: "declined",
            component: () => import("./pages/FlexShopperDeclinedView.vue"),
          },
        ],
      },
    ],
  },
]
